const handleMobileMenu = () => {
  const mobileNav = document.querySelector('#left-nav-phone');
  if (mobileNav) {
    const mobileTitle = mobileNav.querySelector('.title');
    if (mobileTitle) {
      mobileTitle.innerHTML = 'MENU';
    }

    const xSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="10.707" height="10.707" viewBox="0 0 10.707 10.707">
    <g id="Group_776" data-name="Group 776" transform="translate(-350.146 -11.146)">
      <line id="Line_34" data-name="Line 34" x2="10" y2="10" transform="translate(350.5 11.5)" fill="none" stroke="#4a4f54" stroke-width="1"/>
      <line id="Line_36" data-name="Line 36" y1="10" x2="10" transform="translate(350.5 11.5)" fill="none" stroke="#4a4f54" stroke-width="1"/>
    </g>
  </svg>
  `;

    const exitButton = mobileNav.querySelector('.exit');
    if (exitButton) {
      exitButton.insertAdjacentHTML('beforebegin', xSVG);
    }
  }

  const navButton = document.querySelector('.nav-toggle');
  if (navButton && !navButton.classList.contains('nav-text')) {
    const newMenuText = document.createElement('p');
    newMenuText.innerHTML = 'MENU';
    navButton.classList.add('nav-text');
    navButton.append(newMenuText);
  }
};

const updateHomeIcon = () => {
  const homeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="21.317" height="19.382" viewBox="0 0 21.317 19.382">
  <path id="Union_18" data-name="Union 18" d="M-6120-4338.709v-1.062h19.937v1.062Zm18.359-1.064h0Zm-16.725,0v-9.444l8.362-5.211,4.036,2.516,2.588,1.613,1.739,1.084v9.443Zm-1.622-10.893,9.976-6.334,4.044,2.531v-1.915h2.588v3.536l3.327,2.108-.571.894-2.756-1.752-2.588-1.62-4.036-2.525-9.414,5.972Z" transform="translate(6120.679 4357.591)" fill="#fff" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
</svg>
`;

  const hubNav = document.querySelector('.top-nav');
  if (hubNav) {
    const homeButton = hubNav.querySelector('li.menu-home a');
    if (homeButton) {
      homeButton.insertAdjacentHTML('afterbegin', homeIcon);
    }
  }
};

module.exports = { handleMobileMenu, updateHomeIcon };



// WEBPACK FOOTER //
// ./scriptPartials/handleMobileMenu.js